import { useEffect } from 'react';

/**
 * Hook para manejar el scroll suave cuando se navega por anclas
 * Se ejecuta cuando cambia el hash de la URL
 */
export const useSmoothScroll = () => {
    useEffect(() => {
        const handleHashChange = () => {
            if (window.location.hash) {
                const element = document.getElementById(window.location.hash.substring(1));
                if (element) {
                    // Pequeño delay para asegurar que el contenido esté renderizado
                    setTimeout(() => {
                        element.scrollIntoView({ 
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }, 100);
                }
            }
        };

        // Manejar el hash inicial cuando se carga la página
        if (window.location.hash) {
            // Delay más largo para el hash inicial para asegurar que el contenido esté renderizado
            setTimeout(() => {
                const element = document.getElementById(window.location.hash.substring(1));
                if (element) {
                    element.scrollIntoView({ 
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }, 500);
        }

        // Manejar cambios en el hash
        window.addEventListener('hashchange', handleHashChange);

        // Limpiar el event listener
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);
};

export default useSmoothScroll;
